const uScore = require('underscore');
import * as moment from 'moment';
import * as numeral from 'numeral';
import * as lodash from 'lodash';
import { translate } from './Intl';
export { translate } from './Intl';

numeral.locale('custom');
uScore.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g
};

const addLibrariesToContext = (values: Object): Object => {
  const $ = translate;
  return Object.assign({}, values, { moment, numeral, _: lodash, $ });
};

// nahradit 'rls?' za router.location.state && router.location.state
const replaceExpression = (expression: string) => {
  //console.log("exp", expression);

  expression = String(expression)
    .replace(/rls\?/g, 'router.location.state && router.location.state')
    .replace(/rid\?/g, 'resources.item.data && resources.item.data');

  return expression;
}

export const renderTemplate = (
  template: string | boolean | null | undefined,
  values: any
): string | null => {

  if (!template) {
    return null;
  }

  if (typeof template === 'string') {
    template = replaceExpression(template);
  }

  try {
    let temp = uScore.template(template);
    values = addLibrariesToContext(values);
    let v = temp(values);
    return v;
  } catch (err) {
    return err.message;
  }
};

export const evaluate = (expression: string | boolean, values: any): any => {
  if (typeof expression === 'boolean') {
    return expression;
  }

  values = addLibrariesToContext(values);
  const keys = Object.keys(values);
  expression = replaceExpression(expression);

  const fn = new Function(
    ...keys,
    expression.indexOf('return') === -1 ? `return (${expression})` : expression
  );
  let _values: any[] = [];
  for (let key of keys) {
    _values.push(values[key]);
  }
  try {
    return fn(..._values);
  } catch (err) {
    console.log('failed to evaluate', expression, values, err);
  }
  return undefined;
};

export const evaluateObject = (
  object: { [key: string]: any },
  values: any,
  fn = evaluate
): { [key: string]: any } => {
  const res = {};

  for (let key of Object.keys(object)) {
    const value = object[key];
    if (typeof value === 'object') {
      res[key] = evaluateObject(value, values, fn);
    } else if (typeof value === 'string') {
      res[key] = fn(value, values);
    } else {
      res[key] = value;
    }
  }

  return res;
};

export const renderObject = (
  object: { [key: string]: any },
  values: any
): { [key: string]: any } => {
  return evaluateObject(object, values, renderTemplate);
};

export const runAction = (
  actionTemplate: string | undefined,
  values: any
): string | null => {
  if (!actionTemplate) {
    return null;
  }
  return evaluate(actionTemplate, values);
  // const template = '{{' + actionTemplate + '}}';
  // return renderTemplate(template, values);
};



// WEBPACK FOOTER //
// ./src/utils/StringUtils.ts